import React from 'react';

/**
 * Shared hub-page header — transparent, no divider, flush with the site header.
 * Width and spacing match the Ausflugsideen container.
 * Props:
 *   title       – main h1 text
 *   subtitle    – optional paragraph below title
 *   actions     – optional JSX rendered below title/subtitle (left-aligned)
 *   inlineAction – optional JSX rendered top-right of title (for icon-only buttons like Share)
 */
export default function PageHeader({ title, subtitle, actions, inlineAction, className = '' }) {
  return (
    <section className={`-mt-[88px] md:-mt-[112px] pt-[88px] md:pt-[112px] ${className}`}>
      <div className="container mx-auto px-3 sm:px-4 md:px-5 py-6">
        <div className="flex items-start justify-between gap-3">
          <div className="max-w-4xl">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">{title}</h1>
            {subtitle && <p className="text-gray-600">{subtitle}</p>}
            {actions && <div className="flex mt-6">{actions}</div>}
          </div>
          {inlineAction && <div className="shrink-0">{inlineAction}</div>}
        </div>
      </div>
    </section>
  );
}